import React, { Dispatch, SetStateAction } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button, Grid } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/styled-components';
import VictimCard from 'containers/CourtManagerLegalProceedings/victimCard';
import CustomBloc from 'components/CustomBloc';
import RequestIcon from 'components/SahamIcons/RequestIcon';
import { VictimForm } from 'containers/CourtManagerLegalProceedings/typings';
import { Listings } from 'containers/AppContainer/typings';
import { VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';

export interface VictimFormComponentProps {
  intl: IntlShape;
  listings: Listings;
  claimId: number;
  victimFormValues: { [key: string]: VictimType };
  setVictimFormValues: Dispatch<SetStateAction<{ [key: string]: VictimType }>>;
  addVictimForm: () => void;
  victimValidation?: any;
  isRejected?: boolean;
  isLawyer?: boolean;
  isCourtManager?: boolean;
  claimRecap: ClaimRecapType;
}
const VictimFormComponent: React.FC<VictimFormComponentProps> = (
  props,
): JSX.Element => {
  const { victimFormValues, setVictimFormValues } = props;

  const setOneFormValuesVictim = (id: string) => (
    newVictimFormValue: VictimForm,
  ) => {
    setVictimFormValues(
      prevVictimFormValues =>
        (({
          ...prevVictimFormValues,
          [id]: newVictimFormValue,
        } as unknown) as any),
    );
  };

  return (
    <>
      <FormContainer>
        <Grid container direction="column" spacing={2}>
          <CustomBloc
            title={translate(messages.addVictim, props)}
            icon={<RequestIcon width="19" height="25" />}
            rightButton={
              <Button onClick={props.addVictimForm}>
                <AddCircleOutlineIcon className="icon" />
                <div className="title-button">
                  {translate({ ...messages.addVictim }, props)}
                </div>
              </Button>
            }
          >
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                {Object.keys(victimFormValues).map(
                  (key: string, index: number) => (
                    <VictimCard
                      nbr={index + 1}
                      listings={props.listings}
                      formValues={victimFormValues[key]}
                      setFormValues={setOneFormValuesVictim(key)}
                      victimValidation={props.victimValidation}
                      isRejected={props.isRejected}
                      isLawyer={props.isLawyer}
                      isCourtManager={props.isCourtManager}
                      claimRecap={props.claimRecap}
                    />
                  ),
                )}
              </Grid>
            </Grid>
          </CustomBloc>
        </Grid>
      </FormContainer>
    </>
  );
};

export default injectIntl(VictimFormComponent);
